import apiClient from "./apiClient";

/**
 * Assignment Service
 * Fetches user company/outlet assignments and related data
 */

export interface CompanyAssignment {
  id: string;
  user_id: string;
  company_id: string;
  role: string;
  is_active: boolean;
  legal_name: string;
  trade_name: string;
}

export interface OutletAssignment {
  id: string;
  user_id: string;
  outlet_id: string;
  role: string;
  is_active: boolean;
  outlet_name: string;
  company_id: string;
}

export interface UserAssignments {
  isCashier: boolean;
  companyAssignments: CompanyAssignment[];
  outletAssignments: OutletAssignment[];
  cashRegisterAssignments: Array<{
    cash_register_id: string;
    outlet_id: string;
    company_id: string;
  }>;
}

export async function getMyAssignments(): Promise<UserAssignments> {
  const response = await apiClient.get("/api/auth/me/assignments");
  const companyAssignments = response.companyAssignments || [];
  const outletAssignments = response.outletAssignments || [];
  const inferredIsCashier = [...companyAssignments, ...outletAssignments].some(
    (assignment: any) =>
      String(assignment?.role || "").toLowerCase() === "cashier",
  );

  return {
    isCashier: response.isCashier === true || inferredIsCashier,
    companyAssignments,
    outletAssignments,
    cashRegisterAssignments: response.cashRegisterAssignments || [],
  };
}

export async function getOutletRegisters(outletId: string) {
  const response = await apiClient.get(`/api/registers?outlet_id=${outletId}`);
  return response.registers || [];
}

export async function getRegistersForOutlets(outletIds: string[]) {
  const allRegisters: any[] = [];
  for (const outletId of outletIds) {
    const registers = await getOutletRegisters(outletId);
    allRegisters.push(
      ...registers.map((r: any) => ({ ...r, outlet_id: outletId })),
    );
  }
  return allRegisters;
}

const assignmentService = {
  getMyAssignments,
  getOutletRegisters,
  getRegistersForOutlets,
};

export default assignmentService;
